/**
 * @generated SignedSource<<f61691a7975907dd5031a1242014e86a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AiGenerationInput = {
  currentAttributes: ReadonlyArray<AiGenerationExistingAttributeInput>;
  materials: ReadonlyArray<AiGenerationMaterialsInput>;
  meshes: ReadonlyArray<AiGenerationMeshesInput>;
  prompt: string;
};
export type AiGenerationMaterialsInput = {
  description?: string | null;
  id: string;
  name: string;
  tags: ReadonlyArray<string>;
};
export type AiGenerationMeshesInput = {
  description?: string | null;
  id: string;
  isVisible?: boolean | null;
  materialID?: string | null;
  name: string;
  parentID?: string | null;
  path?: string | null;
  tags: ReadonlyArray<string>;
};
export type AiGenerationExistingAttributeInput = {
  description?: string | null;
  id: string;
  name: string;
  options: ReadonlyArray<AiGenerationExistingOptionInput>;
  parentID?: string | null;
  type: string;
};
export type AiGenerationExistingOptionInput = {
  description?: string | null;
  id: string;
  name: string;
};
export type composerQueriesGenerateAiAttributesQuery$variables = {
  input: AiGenerationInput;
};
export type composerQueriesGenerateAiAttributesQuery$data = {
  readonly generatedAIAttributes: {
    readonly attributes: ReadonlyArray<{
      readonly an: string | null;
      readonly o: ReadonlyArray<{
        readonly a: ReadonlyArray<{
          readonly m: ReadonlyArray<string | null> | null;
          readonly mat: string | null;
          readonly t: string | null;
        } | null> | null;
        readonly on: string | null;
      } | null> | null;
    }>;
    readonly handoffPrompt: string | null;
    readonly outOfScope: boolean;
    readonly supportRequest: {
      readonly description: string;
      readonly subject: string;
    } | null;
  };
};
export type composerQueriesGenerateAiAttributesQuery = {
  response: composerQueriesGenerateAiAttributesQuery$data;
  variables: composerQueriesGenerateAiAttributesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateAttributesByPromptResult",
    "kind": "LinkedField",
    "name": "generatedAIAttributes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailSupportRequest",
        "kind": "LinkedField",
        "name": "supportRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outOfScope",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "handoffPrompt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GenerateAttributesByPromptAttributes",
        "kind": "LinkedField",
        "name": "attributes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "an",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GenerateAttributeByPromptOptions",
            "kind": "LinkedField",
            "name": "o",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GenerateAttributeByPromptActions",
                "kind": "LinkedField",
                "name": "a",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "t",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "m",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mat",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "on",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesGenerateAiAttributesQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "composerQueriesGenerateAiAttributesQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b697c06606b8557eb39a2f7192795ed0",
    "id": null,
    "metadata": {},
    "name": "composerQueriesGenerateAiAttributesQuery",
    "operationKind": "query",
    "text": "query composerQueriesGenerateAiAttributesQuery(\n  $input: AiGenerationInput!\n) {\n  generatedAIAttributes(input: $input) {\n    supportRequest {\n      subject\n      description\n    }\n    outOfScope\n    handoffPrompt\n    attributes {\n      an\n      o {\n        a {\n          t\n          m\n          mat\n        }\n        on\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "76ae496ffc4aa97fc7fcc324f71caaf1";

export default node;
